import Cookies from 'js-cookie';
import './province-selector.scss';


const REGION_CANADA_ID = 1;
const QUEBEC_ID = '10';

(function (Drupal, window, document, once) {
  Drupal.behaviors.sollioprovinceSelectorToggle = {
    attach (context) {
      // Function to open province selector panel.
      function openProvincePanel() {
        document.querySelectorAll('.province-selector-content').forEach(panel => {
          panel.classList.add('open');
          panel.style.display = 'block';
        });
        document.getElementById('province-selector-overlay').style.display = 'block';
        document.body.classList.add('prevent-scroll');
      }

      // Function to close province selector panel.
      function closeProvincePanel() {
        document.querySelectorAll('.province-selector-content').forEach(panel => {
          panel.classList.remove('open');
          panel.style.display = 'none';
        });
        document.getElementById('province-selector-overlay').style.display = 'none';
        document.body.classList.remove('prevent-scroll');
      }

      // Function to check if province panel is open.
      function isProvincePanelOpen() {
        return document.querySelector('.province-selector-content.open') !== null;
      }

      // province selector toggle
      window.addEventListener('load', () => {
        once('province-selector-toggle', '.province-selector-toggle', context).forEach(toggle => {
          const provinceOverlay = document.getElementById('province-selector-overlay');

          toggle.addEventListener('click', (event) => {
            event.preventDefault();

            if (isProvincePanelOpen()) {
              closeProvincePanel();
            } else {
              openProvincePanel();
            }
          });

          // Close province panel when clicking on overlay (outside panel).
          if (provinceOverlay) {
            provinceOverlay.addEventListener('click', (event) => {
              event.preventDefault();
              closeProvincePanel();
            });
          }
        });
      });
    },
  };
}(Drupal, window, document, once));


jQuery(document).ready(function ($) {
  // check if user has province preference cookie
  const visitorProvince = Cookies.get('visitor_province');

  window.visitorProvince = visitorProvince;

  if (visitorProvince !== null && Number.isInteger(1 * visitorProvince)) {
    // Fix for usage when logged in Drupal admin
    window.setTimeout(function () {
      const selectedProvinceRadioEl = document.getElementById(`province_selector_${visitorProvince}`);
      selectedProvinceRadioEl.checked = true;

      displayCurrentProvince(visitorProvince);
      displayQuebecSpecificLabels(visitorProvince === QUEBEC_ID);

      const regionId = selectedProvinceRadioEl.parentNode.dataset.regionId;
      displayBannerImageByRegion(regionId);
      setBannerBackground(regionId);
    }, 50);
  } else {
    makeAjaxCallGetIp();
    displayBannerImageByRegion(REGION_CANADA_ID);
    setBannerBackground(REGION_CANADA_ID);
  }
  // Fix for usage when logged in Drupal admin
  window.setTimeout(function () {
    $(".provinceSelector .province_input").on('click', function () {
      //on click on a province, select this province as the current one
      const provinceId = $(this).parent().attr('data-province-id');
      const regionId = $(this).parent().attr('data-region-id');
      $('.province_input').removeAttr('checked');
      $(this).attr('checked', true);

      actionOnProvinceChange(regionId, provinceId);

      // close menu after selecting
      $(this).parents('.menuparent').removeClass('open');
    });
  }, 50);

  document.addEventListener('relatedLoaded', () => {

    if (visitorProvince !== null && Number.isInteger(1 * visitorProvince)) {
      displayCurrentProvince(visitorProvince);
      const selectedProvinceRadioEl = $('#province_selector_' + visitorProvince);
      selectedProvinceRadioEl.attr('checked', true);
      displayQuebecSpecificLabels(visitorProvince === QUEBEC_ID);


      const regionId = selectedProvinceRadioEl.parent().attr('data-region-id');
      displayBannerImageByRegion(regionId);
      setBannerBackground(regionId);
    } else {
      displayBannerImageByRegion(REGION_CANADA_ID);
      setBannerBackground(REGION_CANADA_ID);
    }
  });

});

function displayCurrentProvince(provinceId) {
  let provinceLabel = 'Province';
  if (getProvinceName(provinceId)) {
    provinceLabel = `Province - ${getProvinceName(provinceId)}`;
  }
  document.querySelector('.currentProvinceLabel').innerHTML = provinceLabel;
}

function getProvinceName(provinceId) {
  return document.querySelector(`.provinceSelector .province[data-province-id="${provinceId}"]`).dataset.provinceName;
}

function displayQuebecSpecificLabels(isQuebec) {
  if (isQuebec) {
    switchLocalizedLabels('defaultRegionLabel', 'quebecLabel', '[data-quebec-label]');
    switchLocalizedUrls('defaultRegionUrl', 'quebecUrl', '[data-quebec-url]');

    // change quebec-specific url in browser if meta tag exists
    if (document.getElementById('MetaTagQuebecPageUrl') !== null) {
      history.replaceState(
        null,
        '',
        document.getElementById('MetaTagQuebecPageUrl').getAttribute('content') + window.location.search
      );
    }

  } else {
    switchLocalizedLabels('quebecLabel', 'defaultRegionLabel', '[data-default-region-label]');
    switchLocalizedUrls('quebecUrl', 'defaultRegionUrl', '[data-default-region-url]');

    // change to non-quebec-specific url in browser if meta tag exists
    if (document.getElementById('MetaTagOriginalPageUrl') !== null) {
      history.replaceState(
        null,
        '',
        document.getElementById('MetaTagOriginalPageUrl').getAttribute('content') + window.location.search
      );
    }
  }
}

function switchLocalizedLabels(from, to, labelsEls) {
  const allLabels = Array.from(document.querySelectorAll(labelsEls));
  const labels = allLabels.filter(label => label.dataset[to] !== '');

  const allinputs = Array.from(document.querySelectorAll('input'+labelsEls));
  const inputsLabels = allinputs.filter(label => label.dataset[to] !== '');

  labels.forEach(label => {
    if (label.innerText !== label.dataset[to]) {
      label.dataset[from] = label.innerText;
      label.innerText = label.dataset[to];
    }
  });

  inputsLabels.forEach(label => {
    if (label.placeholder  !== label.dataset[to]) {
      label.dataset[from] = label.placeholder;
      label.placeholder  = label.dataset[to];
    }
  });
}

function switchLocalizedUrls(from, to, labelsEls) {
  const allLabels = Array.from(document.querySelectorAll(labelsEls));
  const labels = allLabels.filter(label => label.dataset[to] !== '');

  labels.forEach(label => {
    if (label.href !== label.dataset[to]) {
      label.dataset[from] = label.href;
      label.href = label.dataset[to];
    }
  });

}

/*
 * Display image banner depending on visitor's preference region
 */
function displayBannerImageByRegion(regionId) {
  // field--name-field-image-de-banniere: used in news content
  const banners = document.querySelectorAll('.field--name-field-image-de-banniere, .card-image, .views-field-field-image-de-banniere,.field--name-field-images, .card-img-top');

  banners.forEach(banner => {
    const isDisplayed = displayImageForABanner(regionId, banner);

    if (regionId !== REGION_CANADA_ID && !isDisplayed) {
      // if no image available for current region in the banner
      // fallback to displaying for region id 1 (Canada)
      displayImageForABanner(REGION_CANADA_ID, banner);
    }
  });
}

/*
 * Display a specific image in a banner based on region.
 * A banner can have multiple images, 1 by region.
 * We display the first
 */
function displayImageForABanner(regionId, banner) {
  let isDisplayed = false;

  banner.querySelectorAll('.field__item[data-region-id], .paragraph-region[data-region-id]').forEach(bannerImage => {
    if (!isDisplayed && bannerImage.getAttribute('data-region-id').includes(regionId)) {
      bannerImage.setAttribute('style', '');
      isDisplayed = true;

      // Hide the placeholder image if it exists.
      const existingPlaceholder = bannerImage.nextElementSibling;
      if (existingPlaceholder && existingPlaceholder.classList.contains('placeholder-image')) {
        existingPlaceholder.setAttribute('style', 'display: none;');
      }
    }
    else {
      // Append placeholder image after bannerImage based on language code.
      const langCode = drupalSettings.path.currentLanguage;
      const placeholderImageSrc = langCode === 'fr'
        ? '/themes/custom/sollio/images/articles/image-placeholder-article-fr.png'
        : '/themes/custom/sollio/images/articles/image-placeholder-article-en.png';

      // Check if placeholder image already exists to avoid duplicates.
      const existingPlaceholder = bannerImage.nextElementSibling;
      if (!existingPlaceholder || !existingPlaceholder.classList.contains('placeholder-image')) {
        const placeholderImg = document.createElement('img');
        placeholderImg.src = placeholderImageSrc;
        placeholderImg.classList.add('placeholder-image');
        placeholderImg.alt = langCode === 'fr' ? 'Image de remplacement' : 'Placeholder image';

        // Insert the placeholder image after the bannerImage.
        bannerImage.parentNode.insertBefore(placeholderImg, bannerImage.nextSibling);
      }
      else if (existingPlaceholder && existingPlaceholder.classList.contains('placeholder-image')) {
        // Show the existing placeholder image.
        existingPlaceholder.setAttribute('style', '');
      }

      bannerImage.setAttribute('style', 'display: none;');
    }
  });

  return isDisplayed;
}

function setBannerBackground(regionId = REGION_CANADA_ID) {
  const backgroundEls = document.querySelectorAll('[data-back-id]');
  backgroundEls.forEach(backgroundEl => {
    const backId = backgroundEl.dataset.backId;
    const defaultDataEl = document.querySelector(`[data-back-target="${backId}"][data-region-id="${REGION_CANADA_ID}"]`);
    const defaultSrc = (defaultDataEl) ? `url(${defaultDataEl.dataset.src})` : 'none';
    const defaultFormat = (defaultDataEl) ? defaultDataEl.dataset.format : 'horizontale';
    const imageDataEl = document.querySelector(`[data-back-target="${backId}"][data-region-id="${regionId}"]`);

    const format = (imageDataEl) ? imageDataEl.dataset.format : defaultFormat;
    const imgSrc = (imageDataEl) ? `url(${imageDataEl.dataset.src})` : defaultSrc;

    backgroundEl.style.backgroundImage = imgSrc;
    backgroundEl.dataset.format = `format--${format}`;
  });
}
//make the ajax request
function makeAjaxCallGetIp(){
  // const xhr = new XMLHttpRequest();
  // xhr.open('GET', Drupal.url('sollio_core/ajax/get-ip-address-info'), true);
  // xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
  // xhr.onreadystatechange = function () {
  //   if (xhr.readyState === 4 && xhr.status === 200) {
  //     const response = JSON.parse(xhr.responseText);
  //     if (response.province != 0) {
  //       document.querySelector('.provinceSelector #province_selector_' + response.province).checked = true;
  //       actionOnProvinceChange(response.region, response.province);
  //     }
  //   }
  // };
  // xhr.send();
}

function actionOnProvinceChange(regionId, provinceId){
  displayCurrentProvince(provinceId);

  Cookies.set('visitor_province', provinceId);

  if (provinceId === QUEBEC_ID) {
    displayQuebecSpecificLabels(true);
  } else {
    displayQuebecSpecificLabels(false);
  }

  displayBannerImageByRegion(regionId);
  setBannerBackground(regionId);
}

